<template>
  <v-row>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <!-- <v-alert v-model="alert" :type="alertType" dismissible>{{alertMessage}}</v-alert> -->

    <v-row no-gutters class="pa-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Port Shipments</v-subheader
        >
      </v-col>

      <v-col cols="12" sm="12" md="4" class="mt-2 pr-2">
        <v-autocomplete
          class="form-control rounded-0 font-weight-bold"
          solo
          placeholder="Select port"
          :items="sortedPortList"
          item-text="label"
          item-value="un_code"
          clearable
          v-model="selectedPort"
        >
          <template v-slot:item="data">
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:item="data">
            <img :src="CONSTANT.getFlag(data.item.code_country)" class="country-flag" />
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col class="d-flex justify-content-end pt-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon @click="fetchPortShipments()">
              <v-icon size="30" color="primary">mdi-refresh</v-icon>
            </v-btn>
          </template>
          Refresh port shipment list
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row justify="center">
      <span class="primary--text font-weight-bold">IMPORT CLEARANCE</span>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <import-clearance-milestone
          v-model="sortedPortShipments"
          :shipments="portShipments"
          v-on:update-milestone="updatePortShipmentMilestone"
        ></import-clearance-milestone>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const";
import ImportClearanceMilestone from "@/components/shared/milestones/ImportClearanceMilestone.vue";
export default {
  components: {
    ImportClearanceMilestone,
  },
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      portList: [],
      selectedPort: "MYPKG",
      selectedPorts: ["MYPKG", "MYPKG_N", "KUL"],

      portShipments: [],
    };
  },

  created() {
    this.selectedPort = this.$route.query.port_un_code || "MYPKG";
  },

  mounted() {
    this.fetchPorts();
    this.fetchPortShipments();
  },

  watch: {
    selectedPort() {
      // window.location.href = `${constant.HOSTNAME}/user/portshipmenttasks?port_un_code=${this.selectedPort}`;
      // console.log("window.location.hostname: ", window.location.hostname);
      this.fetchPortShipments();
    },
  },

  methods: {
    /**
     * fetch ports
     */
    async fetchPorts() {
      var resp = await this.$https.get("/api/ports");
      // this.portList = resp.data.data || [];
      this.portList = [];

      resp.data.data.forEach((port) => {
        if (this.selectedPorts.includes(port.un_code)) {
          this.portList.push(port);
        }
      });
    },

    /**
     * Fetch port shipment tasks
     */
    async fetchPortShipments() {
      this.$root.blockUImsg = "Loading port shipments";
      this.$root.blockUIshow = true;

      var resp = await this.$https.get(`/api/port_shipment_tasks/${this.selectedPort}`);

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.portShipments = resp.data.data;
      } else {
        this.portShipments = [];
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Update the port shipment milestone
     */
    async updatePortShipmentMilestone(port_shipment, postform) {
      this.$root.blockUImsg = "Updating milestone";
      this.$root.blockUIshow = true;

      var resp = await this.$https.put(
        `/api/port_shipment_tasks/id/${port_shipment.port_shipment_milestone_id}`,
        postform
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        port_shipment.task_level = postform.task_level;
        port_shipment.tasks = postform.tasks;
        port_shipment.milestone_completed = postform.milestone_completed;

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
    },
  },

  computed: {
    sortedPortList() {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    portDictionary() {
      var portDict = {};

      this.sortedPortList.forEach((element) => {
        portDict[element.un_code] = element;
      });

      return portDict;
    },

    sortedPortShipments() {
      // return this.portShipments.sort(function (a, b) {
      //     return a.label.localeCompare(b.label);
      // });

      let ret = {};
      this.portShipments.forEach((element) => {
        if (ret[element.task_level] == null) {
          ret[element.task_level] = [element];
        } else {
          ret[element.task_level].push(element);
        }
      });
      return ret;
    },
  },
};
</script>

<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  padding: 0 0px 10px;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
}

.v-btn--icon.v-size--x-small.add-remove-item {
  height: 16px;
  width: 16px;
}
</style>
